<div class="mb-2">
  <ion-label class="text-[10px] font-black uppercase tracking-widest text-orange-600 ml-1">{{ label() }}</ion-label>
  <div class="password-field">
    <ion-input
      [type]="visible() ? 'text' : 'password'"
      [value]="value()"
      (ionInput)="value.set($any($event).target.value)"
      (keyup.enter)="enter.emit()"
      [placeholder]="placeholder()"
      [attr.autocomplete]="autocomplete()"
      class="bg-slate-50 rounded-2xl px-5 py-2 mt-1 border border-slate-100 password-field__input"
    ></ion-input>
    <button
      type="button"
      class="password-field__toggle"
      (click)="toggleVisibility()"
      [attr.aria-label]="visible() ? 'Hide password' : 'Show password'"
      [attr.aria-pressed]="visible()"
    >
      {{ visible() ? 'Hide' : 'Show' }}
    </button>
  </div>
</div>
